// extracted by mini-css-extract-plugin
export default {"wrapper":"H3-z","play":"I3-z"};